import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const LoadingSpinner = ({
  size = 40,
  borderWidth = 3,
  primaryColor,
  borderColor,
  overlay = false,
  backgroundColor = 'transparent',
  ariaLabel = 'Loading',
  small = false,
}) => {
  const { colors } = useTheme();
  
  // Use theme colors as defaults if not provided
  const finalPrimaryColor = primaryColor || colors.primary || '#007bff';
  const finalBorderColor = borderColor || colors.border || 'rgba(255,255,255,0.3)';
  if (small) {
    return (
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
    );
  }

  const spinner = (
    <div
      className="chart-loading-spinner"
      aria-label={ariaLabel}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderTop: `${borderWidth}px solid ${finalPrimaryColor}`,
        borderRight: `${borderWidth}px solid ${finalBorderColor}`,
        borderBottom: `${borderWidth}px solid ${finalBorderColor}`,
        borderLeft: `${borderWidth}px solid ${finalBorderColor}`,
        borderRadius: '50%'
      }}
    />
  );

  if (!overlay) return spinner;

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor,
      zIndex: 10
    }}>
      {spinner}
    </div>
  );
};

export default LoadingSpinner;


